// // // //

export interface GetRandomNumberInRangeProps {
    min: number;
    max: number;
}

/**
 * getRandomNumberInRange
 * Returns a random number between props.min and props.max
 */
export function getRandomNumberInRange(
    props: GetRandomNumberInRangeProps,
): number {
    const { min, max } = props;
    return Math.random() * (max - min) + min;
}
